import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { PageElement } from './Page';

const EventType = lazy(() =>
    import('@/v1/setting/views/EventType').then((module) => ({
        default: module.EventType,
    }))
);
const EventCategory = lazy(() =>
    import('@/v1/setting/views/EventCategory').then((module) => ({
        default: module.EventCategory,
    }))
);
const EventCode = lazy(() =>
    import('@/v1/setting/views/EventCode').then((module) => ({
        default: module.EventCode,
    }))
);

const EventServiceLevelAgreement = lazy(() =>
    import('@/v1/setting/views/EventServiceLevelAgreement').then((module) => ({
        default: module.EventServiceLevelAgreement,
    }))
);

export const eventSettingRoutes: RouteObject[] = [
    {
        path: `event_type`,
        ...PageElement(<EventType />),
    },
    {
        path: `event_category`,
        ...PageElement(<EventCategory />),
    },
    {
        path: `event_code`,
        ...PageElement(<EventCode />),
    },
    {
        path: `event_service_level_agreement`,
        ...PageElement(<EventServiceLevelAgreement />),
    },
];
